export default __webpack_public_path__ + "static/media/private_tutoring.fba55ba3.jpg";